export const enum DatePatterns {
    FULL_DATE = `DD MMMM YYYY`,
    DATE = `D MMMM YYYY`,
    ABBREVIATED_DATE = `D MMM YYYY`,
    SHORT_DATE = `D MMM`,
    TWENTY_FOUR_HOUR_TIME = `HH:mm:ss`,
    SHORT_TIME = `h.mm a`,
    DAY_DATE = `dddd DD MMMM YYYY`,
    YEAR_MONTH_DAY = `YYYY-MM-DD`,
}